<template>
  <div class="job">
    <v-header />
    <div class="job-city">
      <div
        class="city-item"
        v-for="(item, index) in cityList"
        :key="index"
        @click="getCityId(item.id, item.shortName)"
      >
        <img :src="item.mobileIcon" alt="" />
        <p :class="isChecked == item.id ? 'ischeck' : ''">
          {{ item.shortName }}
        </p>
      </div>
    </div>
    <!-- <swiper :options="swiperOption">
      <swiper-slide>
        <div :class="isChecked===0 ? 'ischeck':''" class="checked" @click="getNewestJob()">最新</div>
      </swiper-slide>
      <swiper-slide
        v-for="(item,index) in cityList"
        :key="index"
        @click.native="getCityId(item.id,item.shortName)"
      >
        <div :class="isChecked==item.id ? 'ischeck':''">{{item.shortName}}</div>
      </swiper-slide>
    </swiper>
    <Lastest :isShow="isShow" /> -->
    <div class="job-gap"></div>
    <SemesterList
      :cityId="Number(cityId)"
      :shortName="shortName"
      :semesterPageResult="semesterPageResult"
      :obtainInfoList="obtainInfoList"
      :isSemester="isSemester && isChecked !== 0"
      @update="getobtainInfo"
    />
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VHeader from "./header/VHeader";
import SemesterList from "./jiuye/SemesterList";

export default {
  //   name: "carrousel",
  metaInfo: {
    title:
      "就业详情_软件测试零基础就业培训课程_软件测试培训机构_博为峰51Testing软件测试培训官网",
    meta: [
      {
        name: "keywords",
        content: "博为峰51Testing,学员就业详情,软件测试培训"
      },
      {
        name: "description",
        content:
          "博为峰近些年来每年培养10000+学员,绝大多数学员顺利就业，并先后就职于7000+国内外企业，就业单位包括Microsoft、Intel、HP等大型跨国公司，及腾讯、阿里、百度、华为、京东、中国移动等国内知名企业."
      }
    ]
  },
  // JSON-LD 结构化数据
  script: [
    {
      vmid: "json_ld_course",
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Webpage",
            "@id": "https://www.51testing.net/jiuye_sh.html#webpage",
            name:
              "就业详情_软件测试零基础就业培训课程_软件测试培训机构_博为峰51Testing软件测试培训官网",
            description:
              "博为峰近些年来每年培养10000+学员,绝大多数学员顺利就业，并先后就职于7000+国内外企业，就业单位包括Microsoft、Intel、HP等大型跨国公司，及腾讯、阿里、百度、华为、京东、中国移动等国内知名企业.",
            url: "https://www.51testing.net/jiuye_sh.html",
            inLanguage: "zh-CN",
            publisher: {
              "@id": "https://www.boweifeng.com/#organization"
            }
          }
        ]
      }),
      __dangerouslyDisableSanitizers: ["script"]
    }
  ],
  components: {
    swiper,
    swiperSlide,
    VHeader,
    SemesterList
  },
  beforeMount() {
    var url = location.href;
    var str = url.split("/");
    str = str.pop().split(".")[0];
    this.$nextTick(() => {
      switch (str) {
        case "jiuye_sh":
          this.isChecked = 1;
          this.cityId = 1;
          this.shortName = "上海";
          break;
        case "jiuye_bj":
          this.isChecked = 2;
          this.cityId = 2;
          this.shortName = "北京";
          break;
        case "jiuye_sz":
          this.isChecked = 3;
          this.cityId = 3;
          this.shortName = "深圳";
          break;
        case "jiuye_cd":
          this.isChecked = 4;
          this.cityId = 4;
          this.shortName = "成都";
          break;
        case "jiuye_nj":
          this.isChecked = 5;
          this.cityId = 5;
          this.shortName = "南京";
          break;
        case "jiuye_xa":
          this.isChecked = 6;
          this.cityId = 6;
          this.shortName = "西安";
          break;
        case "jiuye_wh":
          this.isChecked = 7;
          this.cityId = 7;
          this.shortName = "武汉";
          break;
        case "jiuye_hz":
          this.isChecked = 8;
          this.cityId = 8;
          this.shortName = "杭州";
          break;
        case "jiuye_cq":
          this.isChecked = 10;
          this.cityId = 10;
          this.shortName = "重庆";
          break;
        case "jiuye_gz":
          this.isChecked = 11;
          this.cityId = 11;
          this.shortName = "广州";
          break;
        default:
          this.isChecked = 1;
          this.shortName = "上海";
          break;
      }
      this.isShow = this.isChecked === 1;
    });
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 7
        // centeredSlides: true
      },
      cityList: [],
      cityId: 0,
      isClass: false,
      shortName: "",
      isSemester: true,
      isShow: true,
      isChecked: "",
      orgList: [],
      semesterPageResult: {},
      obtainInfoList: {}
    };
  },
  mounted() {
    this.getInit();
  },
  // beforeRouteLeave(to, from, next) {
  //   // 设置下一个路由的 meta
  //   to.meta.keepAlive = true; // B 跳转到 A 时，让 A 缓存，即不刷新
  //   next();
  // },
  methods: {
    getInit() {
      this.axios.get("/api/consume/ObtainInfo/ObtainIndex").then(res => {
        this.cityList = res.data.orgList;
        this.semesterPageResult = res.data.semesterPageResult;
        this.obtainInfoList = res.data.obtainInfoList;
      });
    },
    getCityId(id, name) {
      // if (id === 7 || id === 11) return false
      this.cityId = id;
      this.shortName = name;
      this.isClass = true;
      this.isSemester = true;
      this.isShow = false;
      this.isChecked = id;
      // this.pageIndex = 1;
      // (this.isChecked = 2),
      this.getobtainInfo();
      var str = "";
      switch (id) {
        case 1:
          str = "/jiuye_sh.html";
          break;
        case 2:
          str = "/jiuye_bj.html";
          break;
        case 3:
          str = "/jiuye_sz.html";
          break;
        case 4:
          str = "/jiuye_cd.html";
          break;
        case 5:
          str = "/jiuye_nj.html";
          break;
        case 6:
          str = "/jiuye_xa.html";
          break;
        case 7:
          str = "/jiuye_wh.html";
          break;
        case 8:
          str = "/jiuye_hz.html";
          break;
        case 10:
          str = "/jiuye_cq.html";
          break;
        case 11:
          str = "/jiuye_gz.html";
          break;
        default:
          str = "/weekly.html";
          break;
      }
      this.$router.replace(str);
    },
    getobtainInfo() {
      this.axios
        .get("/api/consume/ObtainInfo/ObtainIndex", {
          params: {
            OrgId: this.cityId,
            Width: 102,
            Height: 48,
            FontSize: 14,
            fontName: "Microsoft Yahei"
          }
        })
        .then(res => {
          this.obtainInfoList = Object.assign({}, res.data.obtainInfoList);
        });
    }
    // getNewestJob() {
    //   this.isSemester = false;
    //   this.isShow = true;
    //   this.isChecked = 1;
    //   this.$router.replace('/weekly.html')
    // }
  }
};
</script>
<style scped>
.job .job-city {
  padding: 44px 30px 40px 30px;
  margin-left: -22px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.job .job-city .city-item {
  width: 118px;
  height: 96px;
  text-align: center;
  margin-left: 22px;
  margin-bottom: 30px;
}
.job .job-city .city-item > img {
  width: 51px;
  height: 39px;
}
.job .job-city .city-item > p {
  width: 118px;
  height: 39px;
  line-height: 39px;
  font-size: 26px;
  color: #9c9c9c;
  margin-top: 18px;
}
.job .job-city .city-item > p.ischeck {
  background-color: #298dfb;
  border-radius: 22px;
  color: #fff;
}
.job .job-gap {
  width: 100%;
  height: 12px;
  background-color: #f4f4f4;
}
.job .swiper-container {
  padding: 0px 0;
  text-align: center;
  height: 82px;
  z-index: 1;
  width: 100%;
}
.job .swiper-slide {
  width: auto; /*设为固定值*/
  /*根据内容调整宽度*/
  text-align: center;
  color: #9c9c9c;
  line-height: 82px;
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/Job.vue